module.exports = __webpack_public_path__ + "bc333ea9469b1e3e5ea47245b8f3dffd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/wizard-hat-s.png
// module id = 2804
// module chunks = 0